Barba.Dispatcher.on("transitionCompleted", function () {
    if (document.getElementById("slider")) {
        const slider = new Vue({
            el: '#slider',
            store,
            data: function () {
                return {
                    video: null,
                    fullscreen: false
                }
            },
            computed: {
            },
            mounted: function () {
                this.initSlider();
            },
            methods: {
                initSlider: function() {
                    const that = this;
                    // slider
                    const elem = document.querySelector('.slider__slides');
                    const initialIndex = Math.floor( Math.random() * elem.children.length ); // eerste slide willekeurig aanpassen
                    that.video = videojs('slider__video'); // initieer video

                    const flktyReady = function() {
                        const currentSlide = this;

                        for (let i = 1; i <= currentSlide.slides.length; i++) {
                            that.video.ready(function () { // update afspeeltijd naar eerste willekeurige slide en koppel fullscreen trigger links in de slider
                                const myPlayer = this;

                                if (elem.querySelector(".slider__playbutton--" + i)) {
                                    elem.querySelector(".slider__playbutton--" + i).addEventListener('click', function (e) {
                                        e.preventDefault();
                                        myPlayer.muted(false);
                                        myPlayer.controls(true);
                                        myPlayer.currentTime(0);
                                        myPlayer.el_.querySelector(".vjs-fullscreen-control").click();
                                        that.fullscreen = true;
                                        myPlayer.play();
                                    });
                                }

                                if (i === initialIndex + 1) { // Play if this is the video in the first slide
                                    myPlayer.on('timeupdate', function () {
                                        let loopStart = currentSlide.selectedElement.dataset.starttime;
                                        let loopEnd = currentSlide.selectedElement.dataset.stoptime;

                                        if (myPlayer.currentTime() >= loopEnd && !that.fullscreen) {
                                            myPlayer.currentTime(loopStart);
                                        }
                                    });

                                    myPlayer.currentTime(currentSlide.selectedElement.dataset.starttime);
                                    myPlayer.play();
                                }

                                myPlayer.on('fullscreenchange', function(e) {
                                    let playerIsFullscreen = myPlayer.isFullscreen();

                                    if (playerIsFullscreen === false) {
                                        myPlayer.muted(true);
                                        myPlayer.controls(false);
                                        that.fullscreen = false;
                                    }
                                });
                            });
                        }
                    };

                    const flktyChange = function( index ) {
                        const currentSlide = this;

                        for (let i = 1; i <= currentSlide.slides.length; i++) {
                            that.video.ready(function () { // update afspeeltijd naar volgende slide
                                const myPlayer = this;

                                if (i === (parseInt(index) + 1)) { // Play if this is the video in the current slide
                                    myPlayer.on('timeupdate', function () {
                                        let loopStart = currentSlide.selectedElement.dataset.starttime;
                                        let loopEnd = currentSlide.selectedElement.dataset.stoptime;

                                        if (myPlayer.currentTime() >= loopEnd && !that.fullscreen) {
                                            myPlayer.currentTime(loopStart);
                                        }
                                    });

                                    myPlayer.currentTime(currentSlide.selectedElement.dataset.starttime);
                                    //myPlayer.play();
                                }
                            });
                        }
                    };

                    const flkty = new Flickity( elem, {
                        // options
                        pageDots: false,
                        prevNextButtons: false,
                        autoPlay: 10000,
                        selectedAttraction: 0.015,
                        friction: 0.210,
                        pauseAutoPlayOnHover: true,
                        wrapAround: true,
                        initialIndex: initialIndex,
                        on: {
                            ready: flktyReady,
                            change: flktyChange
                        }
                    });

                    // navigation
                    const navElem = document.querySelector('.slider__nav');
                    if (navElem !== null) {
                        const navFlkty = new Flickity(navElem, {
                            // options
                            asNavFor: ".slider__slides",
                            groupCells: "100%",
                            percentPosition: false,
                            pageDots: false,
                            prevNextButtons: false,
                            pauseAutoPlayOnHover: true,
                        });
                    }

                    Barba.Dispatcher.on("linkClicked", function () {
                        setTimeout(() => {
                            that.video.dispose();
                        }, 100);
                    });
                }
            },
            created: function () {
            },
            destroyed: function () {
            }
        });
    }
});